import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import ReactionContainer from 'srcReact/components/common2/ReactionContainer'
import PostInputArea from 'srcReact/components/common2/FeedsTabContent/components/PostInputArea'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components/actions'
import LinkPreview from 'srcReact/components/common2/LinkPreview'
import ImagePicker from 'srcReact/MessengerPage/components/ImagePicker'
import { redirectToPage } from 'srcReact/helpers/history'
import Popup from 'reactjs-popup'
import FeedPopup from '../FeedPopup'
import EmojiPicker from 'srcReact/components/common2/EmojiPicker'
import Header from '../Header'
import Options from '../Options'
import MessageBody from '../MessageBody'
import Description from '../Description'
import Media from '../Media'
import Footer from '../Footer'
import { commonFeedActions } from 'srcReact/components/common2/FeedsTabContent/actions'
import { proceesImagesWithIK, separateFilesByType } from 'srcReact/helpers/fileHelper'
import PostFeedModal from 'srcReact/components/popinsContent/PostFeedModal'
import { htmlToText, isMobileScreen, uuid } from 'srcReact/helpers/utils'
import queryString from 'query-string'
import Divider from 'srcReact/components/common2/Divider'
import { getPostedResponseId, scrollToElement } from 'srcReact/helpers/feedHelper'

export default function FeedContent({
  className,
  draftMessage,
  entity,
  feed,
  feedIdToScroll,
  feedIndex,
  feeds,
  isDeleteMessagePopupOpen,
  isFeedComments = false,
  isFlagModalOpen,
  isGroupOrganizer,
  isMember,
  isModal = false,
  isOrganizer,
  isParentFeed,
  isPinned = false,
  isStatic,
  level, // will be uncommented for further levels
  parentIndex,
  quantity,
  showReplyButton = false,
  totalUsers,
  type,
  user,
  users,
  addReactionToMessage,
  deleteReactionFromMessage,
  handleOpenPicker,
  handleShowDeleteMessagePopup,
  showImageModal,
  showFlagModal,
  showSendMessageModal,
  showUserModal,
  replyOrCommentSent,
  setReplyOrCommentSent,
  feedIdToExpand,
  isFocusSetRef, // once focus is set, do not apply on subsequest actions like show more/less replies,
  isModalAlreadyOpenRef, // does not open modal, if already opened. Declared at parent which is FeedsTabContent to maintain only one popup,
  feedInFileModal
}) {
  const ref = useRef()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isInputVisible, setIsInputVisible] = useState(isParentFeed)
  const [clearContent, setClearContent] = useState(false)
  const [inputError, setInputError] = useState('')
  const [content, setContent] = useState('')
  const [filesToUpload, setFilesToUpload] = useState([])
  const [sendTriggered, setSendTriggered] = useState(false)
  const [replyButtonClicked, setReplyButtonClicked] = useState(false)

  const [expandRepliesForId, setExpandRepliesForId] = useState(0)
  const [focusInput, setFocusInput] = useState(false)
  const [showNewCommentPopup, setShowNewCommentPopup] = useState(false)
  const [isPostModalOpen, setIsPostModalOpen] = useState(false)
  const [emoji, setEmoji] = useState(null)
  const [finalFilesToUpload, setFinalFilesToUpload] = useState([])
  const [userToTag, setUserToTag] = useState(null)
  const [userTyping, setUserTyping] = useState(false)
  const [visibleRepliesCount, setVisibleRepliesCount] = useState(isModal ? 0 : appConstantSettings.MIN_REPLIES_ON_FEED)
  const [responses, setResponses] = useState([])
  const [fileTuple, setFileTuple] = useState([[], []])
  const {
    commonNewsfeed: {
      feeds: { list: allFeedList },
      createEditFeed,
      reaction,
      organizationId,
      workplaceIds,
      feedTags: { loading: tagsLoading, tags }
    },
    common: { isMobile, isTablet, isNative, isDesktop },
    login: { user: loggedInUser }
  } = useSelector((state) => state)

  //This useEffect sets number of replies that needs to be visible depending on page or modal
  //This useEffect will be called on load, when comment/reply is sent
  useEffect(() => {
    if (level > 1 && feed?.responses?.length > 0) {
      if (isModal || feedInFileModal) {
        //expandRepliesForId === 0 check is for: if reply feed is already expanded and if user does any action on it,
        //it will remain expanded after the action
        //https://app.asana.com/0/1140988629330369/1205590258544187
        //https://app.asana.com/0/1140988629330369/1203709319650565

        //if reply is no expanded and if user replies, then show only those replies which are in non-expand state
        const newReplyCount = expandRepliesForId == 0 ? visibleRepliesCount + 1 : visibleRepliesCount

        //if feed is displayed in file modal and level 2 (image in comment) is displayed as parent feed, show all replies
        if (feedInFileModal && level === 2) {
          setResponses(feed.responses)
        } else {
          const updatedResponse = feed.responses.slice(
            feed.responses.length > newReplyCount ? feed.responses.length - newReplyCount : feed.responses
          )
          setResponses(updatedResponse)
        }

        if (expandRepliesForId === 0 && replyOrCommentSent.sent && replyOrCommentSent.feedId == feed.id) {
          setVisibleRepliesCount(newReplyCount)
        }
      } else {
        //handling replies on page (not modal)
        const updatedResponses = feed.responses.slice(
          0,
          feed.responses.length > appConstantSettings.MIN_REPLIES_ON_FEED && expandRepliesForId === 0
            ? visibleRepliesCount
            : feed.responses.length
        )
        setResponses(updatedResponses)
      }
    } else if (level === 1 && !isModal && !feedInFileModal) {
      //handles comments on page (not modal)
      const updatedResponses = feed.responses
        .slice(feed.responses.length - appConstantSettings.MAX_COMMENTS_ON_FEED)
        .reverse()
      setResponses(updatedResponses)
    } else {
      setResponses(feed.responses)
    }
    if (setReplyOrCommentSent) {
      setReplyOrCommentSent({ feedId: 0, sent: false })
    }
  }, [level, feed, isModal, feedInFileModal])

  useEffect(() => {
    if (!tagsLoading && tags?.length > 0 && fileTuple?.length > 0 && sendTriggered) {
      for (const tag of tags) {
        if (fileTuple[0].length > 0) {
          //if there are images
          proceesImagesWithIK(fileTuple[0], tag)
        }
        //if there are documents
        if (fileTuple[1].length > 0) {
          let startingTagIndex = 1
          if (fileTuple[0].length > 0) {
            //if there are images in post, then tag index for document will be after count of images
            startingTagIndex = startingTagIndex + fileTuple[0].length
          }
          dispatch(
            commonActions.complexFilesCreation(fileTuple[1], tag, 1, 'document,compressed_file', startingTagIndex)
          )
        }
        setSendTriggered(false)
        dispatch(commonFeedActions.removeProcessedtag(tag))
      }
      dispatch(commonFeedActions.updateTagCount())
    }
  }, [tagsLoading, tags, sendTriggered])

  //This useEffect is used to create "click" event listener on all mentions in feed in order to open the light profile modal
  useEffect(() => {
    //Get the pareant element which contains the mention element.
    let feedsWrapper = document.querySelector('[class*="feedsWrapperModal"]')
    if (!feedsWrapper) {
      feedsWrapper = document.querySelector('[class*="feedsWrapper"]')
    }
    let elements
    if (feedsWrapper) {
      //using settimeout to wait to fully load feedswrapper to get mention elements
      setTimeout(() => {
        elements = feedsWrapper.querySelectorAll('span[class="mention"]')
        if (elements) {
          elements.forEach(function (el, index) {
            el.addEventListener(
              'click',
              (e) => {
                e.stopPropagation()
                clickOnMention(el, index)
              },
              false
            )
          })
        }
      }, 500)

      return () => {
        if (elements) {
          elements.forEach(function (el, index) {
            el.removeEventListener('click', () => clickOnMention(el, index))
          })
        }
      }
    }
  }, [])

  const clickOnMention = (element, index) => {
    const { dataset } = element
    if (showUserModal && dataset?.id > 0) {
      const usr = { id: dataset.id }
      showUserModal(usr)
    }
  }

  // Save draft message
  useEffect(() => {
    if (content.length === 0 && userTyping) {
      saveDraft()
    }
    const draftTimer = setTimeout(() => {
      if (content && content.length > 0 && userTyping) {
        saveDraft()
      }
    }, appConstantSettings.SAVE_DRAFT_MESSAGE_TIMOUT)
    return () => clearTimeout(draftTimer)
  }, [content])

  const saveDraft = () => {
    if (
      (focusInput &&
        content !==
          (draftMessage &&
            draftMessage[feed.id_msg_newsfeed] &&
            draftMessage[feed.id_msg_newsfeed][feed.id] &&
            draftMessage[feed.id_msg_newsfeed][feed.id].message)) ||
      content !== (draftMessage && draftMessage[feed.id] && draftMessage[feed.id].message)
    ) {
      dispatch(commonFeedActions.addDraftNewsFeed(feed.id_msg_newsfeed, feed.id, content))
      dispatch(commonFeedActions.saveDraftToState(content, feed.id_msg_newsfeed, feed.id))
    }
  }

  //This useEffect is called when new post/comment/reply is created or edited.
  //Focus is set to newly created content by scrolling and highlight them for 2 seconds
  useEffect(() => {
    if (level > 1) {
      if (createEditFeed.success && !createEditFeed.loading) {
        const originMessageId = createEditFeed.originMessageId
        dispatch(commonFeedActions.setOriginMessageId(0))
        //focus newly posted comment/reply
        const recentltPostedResponseId = getPostedResponseId(allFeedList, originMessageId)
        //response id can be comment id or reply id
        if (recentltPostedResponseId > 0) {
          //if comment id is same, then set the reply count to existing response of comment + 1(for newly added)
          //here we are setting reply count to not show "Show more replies" at the end
          if (feed.id === originMessageId) {
            setVisibleRepliesCount(feed.responses.length + 1)
          }
          focusResponse(recentltPostedResponseId, isModal || feedInFileModal)
        }
        //setIsInputVisible(false) //keeping the input area open after the reply is posted//1206287515615991
      }
    }
  }, [createEditFeed.loading, createEditFeed.success])

  const focusResponse = (idToFocus, isPopup) => {
    setTimeout(() => {
      let elementToScroll = null
      if (isPopup) {
        elementToScroll = document.querySelector(`div[class*='popup-content'] [data-id="${idToFocus}"]`)
      } else {
        elementToScroll = document.querySelector(`[data-id="${idToFocus}"]`)
      }
      scrollToElement(elementToScroll, level, 2000)
      isFocusSetRef.current = true
    }, 500)
  }

  //This useeffect is used to set user tag to reply input when reply button is clicked or new reply modal is opened
  useEffect(() => {
    if (isInputVisible && (replyButtonClicked || showNewCommentPopup)) {
      const userObj = totalUsers.find((u) => u.id === feed.id_user)
      if (userObj) {
        setUserToTag(userObj)
      } else {
        setUserToTag(null)
      }
    } else {
      setUserToTag(null)
    }
    setReplyButtonClicked(false)
  }, [isInputVisible, replyButtonClicked, showNewCommentPopup])

  const showInputArea = (openCreateFeedModal = true) => {
    if (!isInputVisible) {
      setIsInputVisible(true)
    }
    setReplyButtonClicked(true)
    setUserToTag(null)
    focusOnInput()
    //openCreateFeedModal -> when clicking on input area, decides if need to open the modal popup
    //for mobile/tablet screen, we need to open it, so it will true for these devices
    //for desktop, we have inline text area, so it will be false for desktop
    if (openCreateFeedModal) {
      setShowNewCommentPopup(true)
    }
  }

  const hideInputArea = () => {
    setIsInputVisible(false)
  }

  const writeToMember = (anotherUserId) => {
    if (showSendMessageModal) {
      showSendMessageModal(anotherUserId)
    } else {
      redirectToPage(`/0/messenger?userid=${anotherUserId}`, isNative)
    }
  }

  const appendEmoji = (emojiObject) => {
    let alreadyAddedReaction = null

    if (feed.reactions && feed.reactions.length > 0) {
      const filteredReaction = feed.reactions.find((r) => r.unified_unicode === emojiObject.unified)
      if (filteredReaction) {
        alreadyAddedReaction = filteredReaction.users.find((u) => u.id_user === loggedInUser?.id)
      }
    }
    if (alreadyAddedReaction) {
      deleteReactionFromMessage(alreadyAddedReaction.id)
    } else {
      addReactionToMessage(feed.id, emojiObject.unified)
    }
  }

  const appendEmojiToRTE = (emojiObject) => {
    setEmoji(emojiObject)
    setShowNewCommentPopup(true)
  }

  const handleShowFlagModal = (feed) => {
    if (showFlagModal) {
      showFlagModal(feed)
    }
  }

  const handleReactionClick = (reaction, hasLoggedInUserReacted) => {
    if (hasLoggedInUserReacted) {
      const reactionId = reaction.users.find((u) => u.id_user === loggedInUser?.id).id
      deleteReactionFromMessage(reactionId, reaction.unified_unicode, feed.id)
    } else {
      addReactionToMessage(feed.id, reaction.unified_unicode)
    }
  }

  const handleFiles = (newFiles) => {
    setClearContent(false)
    setFinalFilesToUpload(newFiles)
    setInputError('')
  }

  const handleReturn = (e) => {
    // if (!crudFeed.loading && !loadingFile) {
    sendMessage()
    setClearContent(true)
    // }
    return true
  }

  const handleChange = (currentContent, imagesToUpload) => {
    setClearContent(false)
    setInputError('')
    setContent(currentContent)
    setUserTyping(true)
  }

  const getFileError = (fileError) => {
    //1204766477850832
    const exisingErrors = document.querySelectorAll('[class*="feedInputError"]')
    if (exisingErrors?.length > 0) {
      exisingErrors.forEach((errorElement) => {
        errorElement.remove()
      })
    }
    setInputError(fileError)
  }

  const resetAfterMessagePosted = () => {
    setContent('')
    setClearContent(true)
    setEmoji(null)
    setFilesToUpload([])
    setUserToTag(null)
  }

  const callPostMessage = () => {
    dispatch(
      commonFeedActions.postFeed(
        feed.id_msg_newsfeed,
        content,
        level === 3 ? feed.origin_message_id : feed.id,
        '',
        quantity,
        organizationId,
        workplaceIds,
        false
      )
    )

    resetAfterMessagePosted()
    setReplyOrCommentSent({ feedId: level === 3 ? feed.origin_message_id : feed.id, sent: true })
  }

  const sendMessage = () => {
    setInputError('')
    if (finalFilesToUpload.length > 0) {
      try {
        const [images, documents] = separateFilesByType(finalFilesToUpload)
        setFileTuple([images, documents])
        dispatch(
          commonFeedActions.createBackgroundTag(
            feed?.id_msg_newsfeed,
            images.length,
            documents.length,
            level === 3 ? feed.origin_message_id : feed.id,
            content
          )
        )
        setSendTriggered(true)
        resetAfterMessagePosted()
      } catch (error) {
        dispatch(commonActions.startStopFileProcessing('stop'))
        setInputError(error?.message)
      }
    } else if (content.length > 0) {
      callPostMessage()
    } else {
      setInputError(t('messenger.clientErrors.emptyMessageError'))
    }
  }

  const focusOnInput = () => {
    setFocusInput(!focusInput)
  }

  const openNewCommentPopup = () => {
    setShowNewCommentPopup(true)
    setIsInputVisible(true)
  }
  const closeNewCommentPopup = () => {
    setShowNewCommentPopup(false)
    //On mobile, currently when user clicks on reply button we directly open RTE popup. Earlier we used to show inline RTE on click of reply
    //We still keep isInputVisible as true as to not disturb current code. Changing the current gives unexpecetd result related to userToTag
    //This is the reason we are making isInputVisible as false when we close NewCommentPOpup
    // if (level > 1) {
    //   setIsInputVisible(false)
    // }
    //keep the input area after reply is posted //1206287515615991
  }

  const uploadImageCallBack = async (files) => {
    if (files.length > 0) {
      setShowNewCommentPopup(true)

      const filesLimit = appConstantSettings.FILES_LIMIT

      if (files.length <= filesLimit) {
        setFilesToUpload(files)
      } else {
        getFileError(t('messenger.clientErrors.maxFiles', { filesLimit }))
      }
    }
  }

  const openPostModal = () => {
    if (!isModalAlreadyOpenRef.current) {
      setIsPostModalOpen(true)
      let locationObj = queryString.parse(location.search)
      if (locationObj?.feed && !isMobileScreen()) {
        dispatch(commonActions.addUserPageView('feed', feed.id))
      }
      isModalAlreadyOpenRef.current = true
    }
  }
  const closePostModal = () => {
    setIsPostModalOpen(false)
    isModalAlreadyOpenRef.current = false
    document.body.style.overflow = 'unset'
  }

  //this function is called when click on show replies(modal) or show more replies link
  const expandReplies = (feedId, all) => {
    setExpandRepliesForId(feedId)
    const newCount = all ? feed.responses.length : visibleRepliesCount + 3
    setVisibleRepliesCount(newCount)
    setResponses(feed.responses.slice(0, feed.responses.length > newCount ? newCount : feed.responses.length))
  }
  //this function is called when click on show less replies link
  const collapseReplies = () => {
    setExpandRepliesForId(0)
    const initialCount = appConstantSettings.MIN_REPLIES_ON_FEED
    setVisibleRepliesCount(appConstantSettings.MIN_REPLIES_ON_FEED)
    setResponses(feed.responses.slice(0, feed.responses.length > initialCount ? initialCount : feed.responses.length))
  }

  //this function is calles on modal popup, when click on hide replies link
  const collapseRepliesAll = () => {
    setExpandRepliesForId(0)
    setVisibleRepliesCount(0)
    setResponses([])
  }

  useEffect(() => {
    if (feedIdToExpand && !isFocusSetRef.current) {
      const isFeedContentPage = location.pathname.includes(`/0/feed-content/`)
      const replyFeed = feed.id == feedIdToExpand ? feed : feed.responses.find((x) => x.id === feedIdToExpand)
      if (!isFeedContentPage && replyFeed) {
        openPostModal()
      }
      if (
        (((level === 1 || level === 2) && feed?.id == feedIdToExpand) || level === 3) &&
        (isModal || isFeedContentPage)
      ) {
        setTimeout(() => expandReplies(feedIdToExpand, true), 100)
        focusResponse(feedIdToScroll, !isFeedContentPage)
      }
    }
  }, [feedIdToExpand, isModal, feedIdToScroll])

  const hasNewFeed = feed.newsfeed_template === 'mixr_creation' || feed.newsfeed_template === 'group_creation'
  return (
    <div ref={ref} className={`${styles.feedContent} ${className} ${isParentFeed && styles.noBorder}`}>
      {isPinned ? (
        <div className={styles.isPinned}>
          <Icon name='pin-badge' alt='pin-badge' />
        </div>
      ) : hasNewFeed ? (
        <div className={`${styles.isNew} ${isModal && styles.isNewInModal}`}>
          {feed.newsfeed_template === 'mixr_creation' ? t('global.newMixr') : t('global.newGroup')}
        </div>
      ) : null}
      {level > 1 && <Divider className={styles.divider} />}
      <div data-id={feed.id} className={`${styles.content} ${isParentFeed && styles.parentContent}`}>
        <Header
          feed={feed}
          user={user}
          type={type}
          isNative={isNative}
          isMobile={isMobile}
          isDesktop={isDesktop}
          isComment={isFeedComments}
          hasNewFeed={hasNewFeed}
          showUserModal={showUserModal}
          level={level}
          renderOptions={() => (
            <Options
              feed={feed}
              type={type}
              user={user}
              isFeedComments={isFeedComments}
              isOrganizer={isOrganizer}
              isGroupOrganizer={isGroupOrganizer}
              handleShowDeleteMessagePopup={handleShowDeleteMessagePopup}
              writeToMember={writeToMember}
              showFlagReasonsPopup={handleShowFlagModal}
              entity={entity}
            />
          )}
        />

        <MessageBody
          feed={feed}
          entity={entity}
          user={user}
          isComment={isFeedComments}
          isNative={isNative}
          isMobile={isMobile}
          showUserModal={showUserModal}
          level={level}
          isModal={isModal}
          renderDescription={() => <Description feed={feed} />}
          renderLinkPreview={(isGifLink) => (
            <LinkPreview
              isGifLink={isGifLink}
              data={feed.message}
              containerCSS={`${styles.linkPreviewContainer} ${level > 1 && styles.linkPreviewContainerComment}`}
            />
          )}
        />
        {/* If feed is in file popup, then show the images. If feed is parent, then it will be seen in separate file navigation */}
        {feed && feed.files && ((feedInFileModal && isFeedComments) || !feedInFileModal) && (
          <Media
            level={level}
            files={feed.files}
            feed={level === 3 ? null : feed}
            isComment={isFeedComments}
            isFilesOwner={feed.id_user === loggedInUser?.id}
            showImageModal={showImageModal}
            isNative={isNative}
            isMobile={isMobile}
            isTablet={isTablet}
            isModal={isModal}
            feedInFileModal={feedInFileModal}
            parentElementId={isModal || feedInFileModal ? null : 'feedWrapper'}
          />
        )}

        <Footer
          feed={feed}
          level={level}
          isModal={isModal}
          visibleRepliesCount={visibleRepliesCount}
          isInputVisible={isInputVisible}
          showReplyButton={showReplyButton}
          openPostModal={openPostModal}
          expandReplies={expandReplies} // when click on comment icon(with comment count)
          collapseReplies={collapseReplies}
          collapseRepliesAll={collapseRepliesAll}
          showInputArea={showInputArea}
          hideInputArea={hideInputArea}
          feedInFileModal={feedInFileModal}
          renderReactionContainer={
            isMember
              ? () => (
                  <ReactionContainer
                    messageId={feed.id}
                    reactions={feed ? feed.reactions : []}
                    appendEmoji={appendEmoji}
                    handleOpenPicker={handleOpenPicker}
                    handleReactionClick={handleReactionClick}
                    loggedInUser={loggedInUser}
                    isProcessing={reaction.loading}
                    reactionToProcess={reaction.data}
                    className={`${styles.reactionContainer} ${isModal && styles.reactionContainerInModal}`}
                  />
                )
              : null
          }
        />
      </div>
      {isInputVisible && (isMember || type === 'organization') && (
        <div
          className={`${styles.textContainer} ${(isMobile || isNative) && level > 2 && styles.textContainerDeepLevel}`}>
          <Avatar
            imgWrapperSize='xsmall'
            userId={loggedInUser?.id}
            profilePicture={loggedInUser?.profile_picture}
            firstname={loggedInUser?.firstname}
            lastname={loggedInUser?.lastname}
            mimeType={loggedInUser?.mime_type}
            originalTag={loggedInUser?.original_tag}
            isOriginal={loggedInUser?.is_original}
            containerCSS={styles.avatarInCommentReply}
          />
          {isMobile || isTablet ? (
            <div className={styles.commentContainer}>
              <button className={styles.btnShowCreatePostPopup} onClick={!isStatic && openNewCommentPopup}>
                {draftMessage && draftMessage[feed.id] && draftMessage[feed.id].message.length > 0 ? (
                  <span className={styles.text}>{htmlToText(draftMessage[feed.id].message)}</span>
                ) : (
                  <span className={styles.text}>
                    {level === 1 ? t('mixrHome.feeds.commentPlaceholder') : t('mixrHome.feeds.replyPlaceholder')}
                  </span>
                )}
              </button>
              <div className={styles.inlineToolbar}>
                <ImagePicker
                  uploadFileCallback={uploadImageCallBack}
                  allowedImageTypes={appConstantSettings.ACCEPTED_IMAGE_TYPES}
                  allowedImageSizeInMB={appConstantSettings.MAX_IMAGE_SIZE_MB}
                  filesLimit={appConstantSettings.FILES_LIMIT}
                  getFileError={getFileError}
                  allowDocs={false}
                  allowImages={true}
                />

                <EmojiPicker
                  containerCss={styles.emojiContainer}
                  appendEmoji={appendEmojiToRTE}
                  iconStyle={styles.emojiIcon}
                  emojiButtonCSS={styles.emojiButton}
                />
              </div>
            </div>
          ) : (
            <PostInputArea
              originMessageId={feed && feed.id}
              feedId={feed && feed.id_msg_newsfeed}
              entity={entity}
              containerCSS={styles.inputAreaContainer}
              showInlineToolbar={true}
              showDocumentPicker={false}
              placeholder={
                isMobile || isNative || feedInFileModal
                  ? level === 1
                    ? t('mixrHome.feeds.comment')
                    : t('mixrHome.feeds.replyMobilePlaceholder')
                  : level === 1
                  ? t('mixrHome.feeds.commentPlaceholder')
                  : t('mixrHome.feeds.replyPlaceholder')
              }
              clearContent={clearContent}
              handleChange={handleChange}
              handleReturn={handleReturn}
              handleFiles={handleFiles}
              getFileError={getFileError}
              handleSendMessage={sendMessage}
              focusInput={focusInput}
              sendButtonCSS={styles.sendButton}
              loadingSendMessage={createEditFeed.loading} //{getLoadingFlag(feed.id)}
              activeUsers={totalUsers}
              inputError={inputError}
              userToTag={userToTag}
              mentionMenuOrientation={isMobile || isNative ? 'top' : 'bottom'}
              draftMessage={draftMessage}
              feedInFileModal={feedInFileModal}
            />
          )}
          {/* add showNewCommentPopup in below condition so that PostFeedModal content does not  execute for all action.
          e.g.in absence of showNewCommentPopup, if image is uploaded on FeedPopup content, it will be added on other feeds */}
          {showNewCommentPopup && (isMobile || isTablet) && (
            <PostFeedModal
              messageType={level === 1 ? 'comment' : level > 1 ? 'reply' : ''}
              commentToUser={user}
              post={feed}
              newsfeedId={feed?.id_msg_newsfeed}
              objectId={entity.id || feed.relation?.id}
              objectName={entity.name || feed.relation?.title}
              objectType={entity.type || feed.relation?.type}
              objectGroupId={entity.groupId}
              existingFeed={{
                message:
                  draftMessage && draftMessage[feed.id] ? draftMessage[feed.id]?.message : emoji ? emoji.emoji : ''
              }}
              objectPicture={entity.picture}
              isModalOpen={showNewCommentPopup}
              closeModal={closeNewCommentPopup}
              enableDraft={true}
              originMessageId={level === 3 ? feed.origin_message_id : feed.id}
              filesFromOuterSelection={filesToUpload}
              userToTag={userToTag}
              setReplyOrCommentSent={setReplyOrCommentSent}
            />
          )}
        </div>
      )}
      {feed.responses.length > 0 && (
        <div
          className={`${styles.comments} ${level === 2 && styles.commentsLevel2} ${
            level === 3 && styles.commentsLevel3
          } `}>
          {responses.map((response, index) => {
            if (
              feedInFileModal ||
              (isModal && level === 1) ||
              (level === 1 && index < appConstantSettings.MAX_COMMENTS_ON_FEED) ||
              (level > 1 && index < visibleRepliesCount) ||
              feed.id === expandRepliesForId
            ) {
              return (
                <FeedContent
                  key={response.id}
                  type={type}
                  feed={response}
                  feeds={feeds}
                  showImageModal={showImageModal}
                  handleShowDeleteMessagePopup={handleShowDeleteMessagePopup}
                  users={users}
                  user={users && users.length > 0 ? users.find((u) => u.id === response.id_user) : null}
                  showReplyButton={false}
                  deleteReactionFromMessage={deleteReactionFromMessage}
                  addReactionToMessage={addReactionToMessage}
                  isFeedComments={true}
                  showUserModal={showUserModal}
                  isGroupOrganizer={isGroupOrganizer}
                  isOrganizer={isOrganizer}
                  isMember={isMember}
                  isParentFeed={false}
                  level={level + 1} //will be uncommented for further levels
                  entity={entity}
                  totalUsers={totalUsers}
                  showSendMessageModal={showSendMessageModal}
                  showFlagModal={showFlagModal}
                  parentIndex={parentIndex}
                  isModal={isModal}
                  feedIdToScroll={feedIdToScroll}
                  feedIdToExpand={feedIdToExpand}
                  draftMessage={draftMessage}
                  isFlagModalOpen={isFlagModalOpen}
                  isDeleteMessagePopupOpen={isDeleteMessagePopupOpen}
                  replyOrCommentSent={replyOrCommentSent}
                  setReplyOrCommentSent={setReplyOrCommentSent}
                  isFocusSetRef={isFocusSetRef}
                  isModalAlreadyOpenRef={isModalAlreadyOpenRef}
                  feedInFileModal={feedInFileModal}
                />
              )
            }
          })}
          {level === 2 &&
            (isModal ? visibleRepliesCount > 0 : visibleRepliesCount > appConstantSettings.MIN_REPLIES_ON_FEED) &&
            visibleRepliesCount < feed.responses.length && (
              <button
                id={`showMoreReply${feed.id}`}
                type='button'
                onClick={() => expandReplies(feed.id)}
                className={`${styles.showMoreComments} ${styles.showMoreCommentsMain}`}>
                {t('mixrHome.feeds.showMoreReplies')}
                <Icon name='arrow-right' size='large24' />
              </button>
            )}
          {/* this condition is used to display "show more comments" link which opens the modal popup */}
          {!isModal &&
            !feedInFileModal &&
            feed.id !== expandRepliesForId &&
            level === 1 &&
            feed.responses.length > appConstantSettings.MAX_COMMENTS_ON_FEED && (
              <button
                type='button'
                {...(!isModal ? { onClick: openPostModal } : {})}
                className={`${styles.showMoreComments} ${styles.showMoreCommentsMain}`}>
                {t('mixrHome.feeds.showMoreComments')}
                <Icon name='arrow-right' size='large24' />
              </button>
            )}
        </div>
      )}
      {isPostModalOpen && feeds?.length > 0 && (
        <Popup
          lockScroll
          closeOnDocumentClick={false}
          // closeOnDocumentClick={isFlagModalOpen || isDeleteMessagePopupOpen || isMobile || isNative ? false : true}
          open={isPostModalOpen}
          onClose={closePostModal}
          className={`feedsWrapperModal ${
            isDesktop
              ? 'postModal'
              : isNative
              ? 'postModalNative'
              : isMobile || isTablet
              ? 'postModalMobile'
              : 'postModal'
          }`}
          contentStyle={
            isMobile || isTablet
              ? {
                  position: 'absolute',
                  padding: '0',
                  paddingBottom: '1.5rem',
                  background: '#fff',
                  width: '100%',
                  boxShadow: '0 2px 6px 1px rgba(0, 0, 0, 0.1)',
                  pointerEvents: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center'
                }
              : {
                  padding: '0',
                  borderRadius: '2rem',
                  position: 'relative',
                  maxHeight: '90vh',
                  minHeight: '34rem',
                  overflow: 'scroll',
                  top: '1rem',
                  scrollbarWidth: 'none',
                  background: 'white',
                  border: 'none',
                  margin: 'auto'
                }
          }
          overlayStyle={
            isMobile || isTablet
              ? { background: 'transparent' }
              : { background: 'rgba(46, 45, 45, 0.3)', backdropFilter: 'blur(4px)' }
          }>
          <FeedPopup
            feeds={feeds}
            feed={feed}
            feedIndex={level > 1 ? parentIndex : feedIndex}
            closeModal={closePostModal}
            key={feed.id}
            type={type}
            showImageModal={showImageModal}
            handleShowDeleteMessagePopup={handleShowDeleteMessagePopup}
            users={users}
            user={users && users.length > 0 ? users.find((u) => u.id === feed.id_user) : null}
            showReplyButton={false}
            deleteReactionFromMessage={deleteReactionFromMessage}
            addReactionToMessage={addReactionToMessage}
            isFeedComments={true}
            showUserModal={showUserModal}
            isGroupOrganizer={isGroupOrganizer}
            isOrganizer={isOrganizer}
            isMember={isMember}
            level={1} //will be uncommented for further levels
            entity={entity}
            totalUsers={totalUsers}
            showSendMessageModal={showSendMessageModal}
            showFlagModal={showFlagModal}
            isMobile={isMobile}
            isTablet={isTablet}
            isNative={isNative}
            isDesktop={isDesktop}
            feedIdToExpand={feedIdToExpand}
            feedIdToScroll={feedIdToScroll}
            draftMessage={draftMessage}
            isFlagModalOpen={isFlagModalOpen}
            isDeleteMessagePopupOpen={isDeleteMessagePopupOpen}
            replyOrCommentSent={replyOrCommentSent}
            setReplyOrCommentSent={setReplyOrCommentSent}
            isFocusSetRef={isFocusSetRef}
            isModalAlreadyOpenRef={isModalAlreadyOpenRef}
          />
        </Popup>
      )}
    </div>
  )
}
